import { useState } from 'react'
import Logo from "../../assets/images/logo.png"
import banner from "../../assets/images/banner.jpeg";
import { FormInput, Button, OTPInput } from "components";
import { validateLogin } from 'components/misc/functions';
import { useDispatch } from 'react-redux';
import { show } from 'providers/toastSlice';
import { Link, useNavigate } from 'react-router-dom';
import { postRequest } from 'https/requests';
import { login } from 'providers/userSlice';
import { STAGING_AUTH } from '../../config/env';

function Login() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [code, setCode] = useState('');
    const [stepOne, setStepOne] = useState(true);
    const [stepTwo, setStepTwo] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [resendProcess, setResendProcess] = useState(false);

    const handleRequest = async(e) => {
        e.preventDefault();
        setProcessing(true);

        // Validate form inputs
        const errors = validateLogin(phone, password);
        for (const [key, value] of Object.entries(errors)) {
            setProcessing(false);
            dispatch(show({
                state : true,
                message : `${value}`,
                type : "error"
            }))
            return;
        }

        let data = {
            phone,
            password
        }

        let res = await postRequest(`${STAGING_AUTH}/login`, data);
        setProcessing(false);
        
        if(res?.err){
            dispatch(show({
                state : true,
                message : `${res?.err}`,
                type : "error"
            }))
            return;
        }

        if(res?.message){
            dispatch(show({
                state : true,
                message : `${res?.message}`,
                type : "success"
            }))

            setStepOne(false);
            setStepTwo(true);
        }

    }

    const handleOTPCode = async(e) => {
        e.preventDefault();
        setProcessing(true);

        let data = {
            phone,
            code
        }

        let res = await postRequest(`${STAGING_AUTH}/verify`, data);
        setProcessing(false);
        
        if(res?.err){
            dispatch(show({
                state : true,
                message : `${res?.err}`,
                type : "error"
            }))
            return;
        }

        dispatch(show({
            state : true,
            message : `Welcome!`,
            type : "success"
        }));

        dispatch(login(res));
        setTimeout(() => {
            navigate("/");
        }, 2000);
    }

    const handleResendRequest = async(e) => {
        e.preventDefault();
        setResendProcess(true);

        let data = {
            phone
        }

        let res = await postRequest(`${STAGING_AUTH}/resend`, data);
        setResendProcess(false);
        
        if(res?.err){
            dispatch(show({
                state : true,
                message : `${res?.err}`,
                type : "error"
            }))
            return;
        }

        dispatch(show({
            state : true,
            message : `${res?.message}`,
            type : "success"
        }));
    }

    return (
        <div className='min-h-screen w-full flex bg-light-bg dark:bg-dark-page relative overflow-hidden'>
            {/* Decorative gradient orbs */}
            <div className='pointer-events-none absolute -top-32 -left-32 w-96 h-96 rounded-full bg-light-blue/10 blur-3xl'></div>
            <div className='pointer-events-none absolute -bottom-32 left-1/4 w-96 h-96 rounded-full bg-logo-red/10 blur-3xl'></div>

            <div className='w-full lg:w-1/2 flex flex-col items-center justify-center px-4 py-10 relative z-10'>
                <div className='w-full max-w-md'>
                    <img src={Logo} alt='Cedispay' className='h-11 w-auto mx-auto mb-8' />

                    <div className='bg-white dark:bg-dark-bg rounded-2xl p-8 md:p-10 shadow-xl shadow-slate-200/60 dark:shadow-black/30 border border-slate-100 dark:border-slate-700'>
                        <div className='mb-7 text-center'>
                            <h1 className='text-2xl md:text-3xl font-semibold text-heading dark:text-slate-100 tracking-tight'>
                                {stepOne ? 'Welcome back' : 'Verify it’s you'}
                            </h1>
                            <p className='mt-2 text-sm text-slate-500 dark:text-slate-400'>
                                {stepOne ? 'Sign in to continue to your Cedispay account.' : `We sent a 4-digit code to ${phone}.`}
                            </p>
                        </div>

                        {stepOne && (
                        <form id="admin-login" onSubmit={handleRequest} className='space-y-5'>
                            <FormInput
                                label='Phone Number'
                                inputMode='numeric'
                                pattern='[0-9]*'
                                name='phone'
                                id='phone'
                                placeholder='e.g. 0244123456'
                                value={phone}
                                setValue={setPhone}
                            />

                            <FormInput
                                label='Password'
                                type='password'
                                name='password'
                                id='password'
                                placeholder='Enter your password'
                                value={password}
                                setValue={setPassword}
                            />

                            <div className='flex justify-end -mt-2'>
                                <Link to="/forgot-password" className='text-sm text-light-blue hover:text-dark-blue font-medium'>
                                    Forgot password?
                                </Link>
                            </div>

                            <Button
                                btnText={"Sign in"}
                                btnType={"submit"}
                                btnClasses={"form-button"}
                                processing={processing}
                            />
                        </form>
                        )}

                        {stepTwo && (
                            <div className='space-y-5'>
                                <form id="admin-login" onSubmit={handleOTPCode} className='space-y-5'>
                                    <div>
                                        <label htmlFor="otp-0" className="form-label">Verification Code</label>
                                        <OTPInput len={4} setInput={setCode} />
                                    </div>

                                    <Button
                                        btnText={"Sign In"}
                                        btnType={"submit"}
                                        btnClasses={"form-button"}
                                        processing={processing}
                                    />
                                </form>

                                <form id='resend-code' onSubmit={handleResendRequest} className='flex items-center justify-center text-sm'>
                                    <span className='text-slate-500 dark:text-slate-400 mr-1'>Didn't get the code?</span>
                                    <Button
                                        btnText={"Resend"}
                                        btnType={"submit"}
                                        btnClasses={"text-light-blue hover:text-dark-blue font-medium"}
                                        processing={resendProcess}
                                    />
                                </form>
                            </div>
                        )}
                    </div>

                    <p className='mt-6 text-center text-sm text-slate-600 dark:text-slate-400'>
                        Don't have an account?{' '}
                        <Link to="/register" className='text-light-blue hover:text-dark-blue font-semibold'>
                            Create one
                        </Link>
                    </p>
                </div>
            </div>

            <div className='hidden lg:block w-1/2 relative p-4'>
                <div className='relative w-full h-full rounded-3xl overflow-hidden shadow-2xl'>
                    <img src={banner} alt="Cedispay" className='absolute inset-0 w-full h-full object-cover' />
                    <div className='absolute inset-0 bg-gradient-to-t from-dark-blue/80 via-dark-blue/20 to-transparent'></div>
                    <div className='absolute bottom-0 left-0 right-0 p-10 text-white'>
                        <h2 className='text-3xl font-semibold leading-tight max-w-md'>
                            Financial support, built around you.
                        </h2>
                        <p className='mt-3 text-white/80 max-w-md'>
                            Apply, track, and manage your loans — all from one place.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login